import { createContext, useContext, useState } from 'react'

import styled from 'styled-components'

export const MentionDisplay = styled.span`
  display: inline-block;
  line-height: 1;
  padding: 0.25rem;
  color: ${({ theme }) => theme.colour.secondary._400};
  background-color: ${({ theme }) => theme.colour.secondary._50};
  border-radius: ${({ theme }) => theme.borderRadius.small};
`

export type MentionData = {
  type: MentionType
  id: string
  name: string // needs to be called "name" for Draft.js reasons...
}

export enum MentionType {
  AdminUser = 'AdminUser',
  Text = 'Text',
}

type Value = {
  mentionData: MentionData[]
  setMentionData: (mentionData: MentionData[]) => void
}

const Context = createContext<Value>({
  mentionData: [],
  setMentionData: () => {},
})

type Props = {
  children: React.ReactNode
}

export const MentionInputProvider: React.FC<Props> = ({ children }) => {
  const [mentionData, setMentionData] = useState<MentionData[]>([])

  return (
    <Context.Provider value={{ mentionData, setMentionData }}>
      {children}
    </Context.Provider>
  )
}

export const useMentionInputContext = () => {
  return useContext(Context)
}
